
import wx from 'weixin-js-sdk'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import banner from '@/assets/mail-banner.png'
import imgup from '@/assets/upload_img.png'
import { AddLetter } from '@/api/youzheng.js'
import { getSex, getLetterType, getCity } from '@/api/sys.js'
import { getConfig, addFile } from '@/api/wx.js'
import Storage from '@/storage'
import store from '@/store'
import config from '@/config/index'
export default {
name: 'declare',
data () {
return {
banner: banner,
mail: {
type: '',
linkername: this.$store.state.user.personObj.acctname,
ishide: 2,
mobile: this.$store.state.user.personObj.mobile,
sexid: '',
idcard: '',
age: '',
companyname: '',
station: '',
linkeremail: '',
cityid: '',
address: '',
title: '',
content: '',
owner_type: config.owner_type,
sourcetype: 1,
fileids: ''
},
upimagelist: [],
index: 0,
imgcount: 5,
fileList: { fileUrlArr: [], fileIdArr: [] },
imgup: imgup,
sexList: [],
sexValue: [],
typelist: [],
typeValue: [],
countrylist: [],
countryValue: [],
baseUrl: config.baseUrl
}
},
components: {
Popup,
Group,
Cell,
XInput,
Selector,
PopupRadio,
XAddress,
XTextarea,
XSwitch,
Flexbox,
FlexboxItem,
XButton,
Tabbar,
TabbarItem,
PopupPicker
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch: {
mail: {
handler (newVal, oldVal) {
if (newVal.ishide == 1) {
this.mail.linkername = '***'
} else {
this.mail.linkername = this.$store.state.user.personObj.acctname
}
},
deep: true
},
'mail.idcard': {
handler: function (newval, oldVal) {
if (newval != '') {
this.mail.age = this.GetAge(newval)
}
}
},
deep: true,
typeValue (newVal, oldVal) {
this.mail.type = newVal[0]
},
sexValue (newVal, oldVal) {
this.mail.sexid = newVal[0]
},
countryValue (newVal, oldVal) {
this.mail.cityid = newVal[0]
}
},
methods: {

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href,
sicode: config.sicode
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['chooseImage', 'uploadImage', 'previewImage'] 
})
})
},

chooseFile (imglist, filelist, imgcount) {

wx.chooseImage({
count: this[imgcount], // 默认5
sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
success: (res) => {
var localIds = res.localIds
this.index = 0
if (localIds.length > 0) {
this[imgcount] = this[imgcount] - localIds.length
this.uploadFile(imglist, filelist, localIds)
}
}
})
},

uploadFile (imglist, filelist, localIds) {
if (this.index >= localIds.length) {
return
}
wx.uploadImage({
localId: localIds[this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
success: res => {
addFile({
mediaId: res.serverId
}).then(re => {
imglist.push(re.returnValue)
filelist.fileUrlArr.push(config.baseUrl + re.returnValue.filepath)
filelist.fileIdArr.push(re.returnValue.id)
})
this.index++
this.uploadFile(imglist, filelist, localIds)
}
})
},

preview (index, filelist) {
wx.previewImage({
current: filelist.fileUrlArr[index], // 当前显示图片的http链接
urls: filelist.fileUrlArr 
})
},

imgclose (imglist, index, filelist, imgcount) {
const _this = this 
this.$vux.confirm.show({
title: '提示',
content: '您确定要删除这张图片么？',

onCancel () {
},
onConfirm () {
_this[imgcount] = _this[imgcount] + 1
imglist.splice(index, 1)
filelist.fileIdArr.splice(index, 1)
}
})
},
getSexName () {
getSex({ addTreeNode: 1 }).then(res => {
res.obj.forEach(item => {
if (item.key != '') {
this.sexList.push({
name: item.value,
value: item.key + ''
})
}
})
})
},
getType () {
getLetterType({ addTreeNode: 1 }).then(res => {
res.obj.forEach(item => {
if (item.key != '') {
this.typelist.push({
name: item.value,
value: item.key + ''
})
}
})
})
},
getCountry () {
getCity({
plistvalue: 31,
addTreeNode: 1
}).then(res => {
if (res.obj.length > 0) {
res.obj.forEach(item => {
if (item.key != '') {
this.countrylist.push({
name: item.value,
value: item.key + ''
})
}
})
}
})
},
addDeclare () {
if (this.mail.type === '') {
this.$vux.toast.text('请选择信件类型', 'middle')
return false
}
if (this.mail.linkername === '') {
this.$vux.toast.text('请填写姓名', 'middle')
return false
}
if (this.mail.ishide === 2 && this.mail.idcard === '') {
this.$vux.toast.text('请填写身份证号码', 'middle')
return false
}
if (this.mail.ishide === 2 && !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(this.mail.idcard)) {
this.$vux.toast.text('身份证号码格式不对哦～', 'middle')
return false
}
if (this.mail.ishide === '') {
this.$vux.toast.text('请选择是否匿名', 'middle')
return false
}
if (this.mail.ishide === 2 && this.mail.sexid === '') {
this.$vux.toast.text('请选择性别', 'middle')
return false
}
if (this.mail.ishide === 2 && this.mail.age === '') {
this.$vux.toast.text('请填写年龄', 'middle')
return false
}
if (this.mail.ishide === 2 && this.mail.mobile === '') {
this.$vux.toast.text('请填写手机号码', 'middle')
return false
}
if (this.mail.ishide === 2 && !(/^1(3|4|5|7|8|9)\d{9}$/.test(this.mail.mobile))) {
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
if (this.mail.ishide === 2 && this.mail.companyname === '') {
this.$vux.toast.text('请填写单位名称', 'middle')
return false
}
if (this.mail.ishide === 2 && this.mail.station === '') {
this.$vux.toast.text('请填写岗位', 'middle')
return false
}
if (this.mail.ishide === 2 && this.mail.linkeremail === '') {
this.$vux.toast.text('请填写邮箱', 'middle')
return false
}
if (this.mail.ishide === 2 && this.mail.cityid === '') {
this.$vux.toast.text('请选择城市', 'middle')
return false
}
if (this.mail.ishide === 2 && this.mail.address === '') {
this.$vux.toast.text('请填写详细地址', 'middle')
return false
}
if (this.mail.title === '') {
this.$vux.toast.text('请填写标题', 'middle')
return false
}
if (this.mail.content === '') {
this.$vux.toast.text('请填写申报内容', 'middle')
return false
}
this.mail.fileids = this.fileList.fileIdArr.join(';')
this.mail = Object.assign(this.mail, { accountid: this.accountid })
AddLetter(this.mail).then(res => {
this.$vux.toast.text('提交成功', 'middle')
this.$router.push({ name: 'myMailWorkZixun', params: { selected: 1 } })
})
},
GetAge (identityCard) {
let len = (identityCard + '').length
if (len == 0) {
return 0
} else {
if ((len != 15) && (len != 18))// 身份证号码只能为15位或18位其它不合法
{
return 0
}
}
let strBirthday = ''
if (len == 18)// 处理18位的身份证号码从号码中得到生日和性别代码
{
strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
}
if (len == 15) {
strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
}

let birthDate = new Date(strBirthday)
let nowDateTime = new Date()
let age = nowDateTime.getFullYear() - birthDate.getFullYear()

if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
age--
}
return age
}
},
activated () {},
created () {
this.wxconfig()
this.getSexName()
this.getType()
this.getCountry()
this.GetAge(this.mail.idcard)
}
}
